<p-select
  appendTo='body'
  scrollHeight='300px'
  [showClear]='showClear' [style]="{width: '100%'}"
  [placeholder]='translationSchema.utils.search | translate'
  [options]="options | translateSelectItems : {translatePath : ''}"
  [ngModel]='value'
  [attr.data-testid]='dataCy || null'
  (ngModelChange)='select($event)' data-testid="value-select">
</p-select>


